// extracted by mini-css-extract-plugin
export default {"weekCarousel":"yVGN6FwjKdGow68XthDQ","active":"iUGUj33pEZHfaoyv3Nt6"};